import { createSelector } from 'reselect'
import createPaymentScheduleSelector from './createPaymentScheduleSelector'
import { PAYMENT_SCHEDULE_TYPE } from 'constants/payment'
import type { StaticPaymentScheduleOption } from 'constants/payment'
import { getReserveForZeroPaymentScheduleRequestInfo } from './reserveForZeroPaymentSchedule'

const offerStaticPaymentScheduleRequestInfo = createPaymentScheduleSelector(PAYMENT_SCHEDULE_TYPE.STATIC)

const getStaticPaymentScheduleOptions = createSelector(
  offerStaticPaymentScheduleRequestInfo,
  getReserveForZeroPaymentScheduleRequestInfo,
  (offerInfo, reserveForZeroInfo): Array<StaticPaymentScheduleOption> => {
    const options: Array<StaticPaymentScheduleOption> = []
    const seen = new Set<string>()

    for (const info of [offerInfo, reserveForZeroInfo]) {
      if (info && !seen.has(info.templateId)) {
        seen.add(info.templateId)
        options.push({ id: info.templateId, requestInfo: info })
      }
    }

    return options
  },
)

export default getStaticPaymentScheduleOptions
